import type { CityConfig } from "@/pages/city-template/types";

export const jamestownConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Jamestown",
  state: "New York",
  stateAbbr: "NY",
  slug: "jamestown",
  route: "/jamestown",
  title: "Emergency Passport Jamestown, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Jamestown, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Jamestown, Chautauqua County, Lake Erie communities, and Western New York travelers.",
  h1: "Emergency & Expedited Passport Services in Jamestown, NY",
  heroSubtitle: "Buffalo Niagara International Airport is 70 miles north. Erie International Airport in Pennsylvania is just 40 miles away. Chautauqua Lake and the Lucille Ball hometown create a unique travel profile — and we help Jamestown residents, from Chautauqua Institution summer scholars to SUNY Fredonia students to Lake Erie shoreline families, get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20aerial%20panorama%20of%20Jamestown%20New%20York%20with%20Chautauqua%20Lake%20sparkling%20in%20golden%20hour%20light%2C%20historic%20downtown%20brick%20architecture%20and%20the%20Lucille%20Ball%20Desi%20Arnaz%20Museum%2C%20rolling%20green%20hills%20of%20Western%20New%20York%2C%20sailboats%20on%20the%20lake%2C%20warm%20amber%20sunset%20reflecting%20on%20water%2C%20professional%20landscape%20photography%20with%20dramatic%20sky%2C%20no%20text%20overlay&width=1800&height=700&seq=jamestown-hero-2026&orientation=landscape",
  heroImageAlt: "Jamestown New York with Chautauqua Lake and historic downtown at golden hour",
  geoPosition: "42.0970;-79.2353",
  geoPlacename: "Jamestown, New York",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Buffalo Passport Agency",
    address: "111 Genesee Street Suite 101, Buffalo, NY 14203",
    distance: "~70 miles from Jamestown — located in downtown Buffalo",
  },
  nearbyCitiesZips: [
    { name: "Jamestown", zips: "14701, 14702" },
    { name: "Dunkirk", zips: "14048" },
    { name: "Fredonia", zips: "14063" },
    { name: "Westfield", zips: "14787" },
    { name: "Lakewood", zips: "14750" },
    { name: "Bemus Point", zips: "14712" },
    { name: "Mayville", zips: "14757" },
    { name: "Silver Creek", zips: "14136" },
    { name: "Buffalo", zips: "14201-14204, 14206-14210" },
    { name: "Erie, PA", zips: "16501-16512" },
    { name: "Rochester", zips: "14602-14627" },
    { name: "Syracuse", zips: "13201-13252" },
    { name: "Elmira", zips: "14901-14905" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing for Western NY", desc: "Reserved courier access to the Buffalo Passport Agency — as fast as 24 hours for Jamestown-area travelers with immediate departures from Buffalo Niagara or Erie International." },
    { icon: "ri-flight-takeoff-line", title: "BUF & ERI Dual-Airport Expertise", desc: "Buffalo Niagara (BUF) at 70 miles and Erie International (ERI) at 40 miles give Jamestown travelers two distinct airport options — we know both airline ecosystems and cross-border dynamics." },
    { icon: "ri-building-2-line", title: "Chautauqua Institution & Arts Travel", desc: "The Chautauqua Institution draws 100,000+ summer visitors. Artists, lecturers, and performers traveling internationally — plus SUNY Fredonia students — create concentrated seasonal passport demand." },
    { icon: "ri-ship-line", title: "Lake Erie & Chautauqua Lake Lifestyle", desc: "From Chautauqua Lake summer homes to Lake Erie shoreline communities, from boating trips to Canada to European lake district tours — Western NY's lake culture drives unique international travel patterns." },
  ],
  internalLinks: [
    { name: "Fast passport services in Buffalo, NY", route: "/buffalo" },
    { name: "Expedited passport in Erie, PA area", route: "/erie-pa" },
    { name: "Quick passport services in Rochester, NY", route: "/rochester" },
    { name: "Urgent passport services in Elmira, NY", route: "/elmira" },
    { name: "New York passport services overview", route: "/newyork" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Jamestown via secure registered courier with direct access to the Buffalo Passport Agency at 111 Genesee Street Suite 101. Our registered couriers hand-deliver your documents — meaning you get faster results without the appointment wait. Jamestown residents can ship from any UPS Store, FedEx Office, or post office location across Chautauqua County.",
  fpcOfficeDistance: "Serving Jamestown, Dunkirk, Fredonia, Westfield, Lakewood, Bemus Point, and all Chautauqua County and Lake Erie communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Jamestown and all of Chautauqua County. From the Furniture Capital to the shores of Chautauqua Lake, from Dunkirk on Lake Erie to the Pennsylvania border — we serve Western New York's southern tier. Our courier service eliminates the need to drive hours to Buffalo or Manhattan for passport processing.",
  nearbyCitiesIntro: "We serve Jamestown and all Chautauqua County communities including Dunkirk, Fredonia, Westfield, Lakewood, Bemus Point, and Mayville. We also serve travelers departing from Buffalo Niagara International Airport and Erie International Airport who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Jamestown as simple as possible — with the efficiency and reliability Western New York travelers need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Jamestown travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Jamestown travelers encounter unique passport issues — everything from cross-border PA airport dynamics to Chautauqua Institution summer season crunch. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Jamestown travelers — from Chautauqua Institution summer residents to Dunkirk harbor families to SUNY Fredonia students — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Jamestown, NY? Here are the most common ones we hear from Chautauqua County and Western New York travelers.",
  statePageRoute: "/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a BUF flight to Europe, an emergency passport for a last-minute trip from Erie, or a first-time passport for a Chautauqua Lake family — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "BUF international flight to Europe in three days? Cross-border trip to Canada this weekend from Erie? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Jamestown-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Jamestown residents renew fast — no agency visit required for most renewals. Perfect for Chautauqua County families, Dunkirk professionals, and Fredonia academics.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Jamestown residents through every step — from downtown to Lakewood to Bemus Point — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your BUF departure or ERI connection is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your Chautauqua Lake family vacation or summer trip to Canada stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Chautauqua County residents after life changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Chautauqua Institution performers, SUNY Fredonia faculty, and Western NY business owners who travel while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Chautauqua County travelers — including Lake Erie boaters with water-damaged documents — through the replacement process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Essential for Jamestown residents who cross into Canada via the Peace Bridge or Niagara Falls.",
      bullets: ["Wallet-size convenience", "Land and sea travel to Canada", "Same expedited processing"],
      badge: "Canada Essential",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Jamestown NY", description: "Urgent passport processing for Jamestown NY travelers with immediate departure needs from Buffalo Niagara or Erie International." },
    { name: "Expedited Passport Renewal Jamestown NY", description: "Fast passport renewal for Jamestown NY residents with a previously-issued passport." },
    { name: "First-Time Passport Jamestown NY", description: "New passport application services for Jamestown NY residents applying for their first passport." },
    { name: "Child Passport Jamestown NY", description: "Minor passport services for Jamestown NY families with children under 16." },
    { name: "Name Change Passport Jamestown NY", description: "Passport name correction after marriage, divorce, or legal name changes for Jamestown residents." },
    { name: "Second Passport Jamestown NY", description: "Second passport services for Jamestown frequent international travelers and Chautauqua Institution performers." },
  ],
  testimonials: [
    {
      name: "Margaret H.",
      location: "Dunkirk, NY",
      rating: 5,
      text: "Family trip to Toronto in 6 days through Buffalo. Fast Passport Center processed my expedited passport in 4 days. They even helped me figure out which post office to visit for the acceptance appointment.",
      service: "Expedited Passport",
    },
    {
      name: "Thomas R.",
      location: "Fredonia, NY",
      rating: 5,
      text: "SUNY Fredonia faculty heading to a conference in Ireland. My passport was expired and I only had 10 days. Fast Passport Center got it renewed in 5 days. The document review caught a signature error.",
      service: "Passport Renewal",
    },
    {
      name: "The Chen Family",
      location: "Lakewood, NY",
      rating: 5,
      text: "Summer at the Chautauqua Institution and we realized our kids' passports expired. Applied from Lakewood — Fast Passport Center walked us through everything. Both passports arrived in 5 days.",
      service: "Child Passport",
    },
    {
      name: "Catherine L.",
      location: "Jamestown, NY",
      rating: 5,
      text: "Second time using Fast Passport Center for Jamestown-to-Europe travel. The consistency is remarkable — same great service, same accurate timelines. Won't use anyone else in Chautauqua County.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "jamestown-1",
      name: "Jamestown Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 E 2nd Street",
      city: "Jamestown",
      state: "NY",
      zip: "14701",
      phone: "(716) 484-0104",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM (appointment required)",
      distance: "Downtown Jamestown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary Jamestown passport acceptance facility. Passport photos available on-site. Book early during summer Chautauqua Institution season — slots fill weeks ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "jamestown-2",
      name: "Dunkirk Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 E 2nd Street",
      city: "Dunkirk",
      state: "NY",
      zip: "14048",
      phone: "(716) 366-4470",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Dunkirk — ~30 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Dunkirk and Lake Erie shoreline residents. Convenient for north Chautauqua County. Less crowded than Jamestown Main during peak season.",
      icon: "ri-mail-line",
    },
    {
      id: "jamestown-3",
      name: "Fredonia Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9 Temple Street",
      city: "Fredonia",
      state: "NY",
      zip: "14063",
      phone: "(716) 679-1094",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM (appointment required)",
      distance: "Fredonia — ~25 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for SUNY Fredonia students and faculty. Passport photos available. Appointment slots fill quickly near semester start and end dates.",
      icon: "ri-mail-line",
    },
    {
      id: "jamestown-4",
      name: "Westfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17 Elm Street",
      city: "Westfield",
      state: "NY",
      zip: "14787",
      phone: "(716) 326-3411",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Westfield — ~20 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Westfield, Barcelona Harbor, and western Chautauqua County. Small facility with limited hours — call ahead to confirm passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "jamestown-5",
      name: "Mayville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5 S Erie Street",
      city: "Mayville",
      state: "NY",
      zip: "14757",
      phone: "(716) 753-3211",
      hours: "Mon–Fri 9:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Mayville — Chautauqua County seat",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "County seat facility at the north end of Chautauqua Lake. Convenient for Mayville, Chautauqua Institution, and Bemus Point residents. Limited appointment slots.",
      icon: "ri-mail-line",
    },
    {
      id: "jamestown-6",
      name: "Chautauqua County Clerk — Mayville",
      type: "County Clerk Passport Acceptance",
      address: "1 N Erie Street",
      city: "Mayville",
      state: "NY",
      zip: "14757",
      phone: "(716) 753-4221",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "Mayville — Chautauqua County seat",
      website: "https://www.chqgov.com/",
      websiteLabel: "Chautauqua County Clerk",
      notes: "Chautauqua County Clerk passport acceptance. Convenient for county seat business. No photo services on-site — bring your own compliant photos.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive to Buffalo Passport Agency in downtown Buffalo (~70 miles from Jamestown)", fpc: "Most Jamestown travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Western NY & BUF/ERI Guidance", agency: "Generic — no BUF, ERI, or Chautauqua County expertise", fpc: "Full BUF/ERI dual-airport and Western New York knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Assuming Erie Airport (PA) Requires Same Documentation as BUF",
      description: "Many Jamestown travelers use Erie International in Pennsylvania for convenience — then discover their passport requirements differ for the specific airline and destination out of ERI vs BUF. Always verify with the specific departure airport.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Jamestown applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Chautauqua County pharmacies produce photos that fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Chautauqua Institution Summer Crunch",
      description: "The 9-week summer season brings 100,000+ visitors. Local acceptance facilities are overwhelmed June–August. Book acceptance appointments 3–4 weeks before your planned submission.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Cross-Border Canada Documentation Confusion",
      description: "Jamestown is just 40 miles from the Peace Bridge. Many residents confuse enhanced driver's license rules with passport requirements — an enhanced license works for land crossings but NOT for flights to Canada.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home in Jamestown or anywhere in Chautauqua County." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Jamestown clients ship from home or the local UPS Store — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 70 miles to Buffalo or wait at the Buffalo Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Jamestown?", a: "We offer Jamestown-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Jamestown office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Jamestown Post Office, Dunkirk Post Office, or Chautauqua County Clerk), then ship documents overnight to our processing center." },
    { q: "Where can I get a passport acceptance in Jamestown?", a: "Jamestown has the Main Post Office (300 E 2nd Street), plus facilities in Dunkirk, Fredonia, Westfield, Mayville, and the Chautauqua County Clerk. We maintain an updated list with hours and appointment availability." },
    { q: "Buffalo (BUF) or Erie (ERI) — which airport should I use?", a: "BUF offers more international flight options (70 miles north). ERI is closer (40 miles, in PA) but has fewer flights. Both are valid departure points. We help you coordinate passport timelines regardless of which airport you choose." },
    { q: "What is the best price for expedited passport service in Jamestown?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers." },
    { q: "Can I get a passport photo in Jamestown?", a: "Yes — CVS Pharmacy, Walgreens, and Walmart all offer passport photos in Jamestown. Photos must be 2x2 inches, white background, no glasses, neutral expression. We review photo compliance before submission." },
    { q: "What about Chautauqua Institution summer visitors?", a: "Seasonal residents and visitors at the Chautauqua Institution often discover passport issues mid-summer. We serve seasonal residents with expedited processing — even those whose permanent address is outside New York." },
    { q: "How do I check my Jamestown passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov." },
    { q: "Can you help with passports for Canada travel from Jamestown?", a: "Yes — Canada is one of the most common destinations for Jamestown travelers. Whether driving across the Peace Bridge or flying from BUF to Toronto, we expedite passports for Canadian travel." },
    { q: "Is there a passport agency closer than Manhattan?", a: "The nearest regional passport agency is the Buffalo Passport Agency at 111 Genesee Street Suite 101, Buffalo, NY 14203 (~70 miles). For most Jamestown travelers, our registered courier service provides faster access than driving to Buffalo." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Jamestown Residents",
    intro: "Jamestown's location in Western New York — with dual airport access in BUF and ERI — and the seasonal rhythm of Chautauqua Lake create distinct passport timing dynamics. Here's what Jamestown travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "BUF — Buffalo Niagara International Airport",
        subtitle: "Western New York's international gateway, ~70 miles from Jamestown",
        description: "Buffalo Niagara International Airport is the primary international departure point for Chautauqua County travelers, with direct flights to major U.S. hubs and seasonal international service. The 70-mile drive on I-90 takes about 75 minutes — close enough for convenience, far enough that a passport issue at the check-in counter means a wasted trip. BUF serves as the international lifeline for all of Western New York south of Buffalo.",
        tip: "BUF's international check-in counters close 60 minutes before departure. Arriving with an expired passport means a 70-mile drive back to Jamestown with no recourse — verify your passport validity before leaving Chautauqua County.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ERI — Erie International Airport (Pennsylvania)",
        subtitle: "Cross-state alternative, ~40 miles from Jamestown",
        description: "Erie International Airport in Pennsylvania is Jamestown's closest airport at just 40 miles. While ERI has a more limited route network than BUF, it serves as a convenient alternative for domestic connections to Chicago, Charlotte, and other hubs. The cross-state dynamic creates a specific risk — Jamestown travelers sometimes book ERI for convenience, then discover the connecting international flight requires a passport at the ERI departure gate.",
        tip: "ERI's smaller size means shorter security lines but also fewer airline customer service resources. If you encounter a passport issue at ERI, there are fewer options for same-day resolution than at a larger airport like BUF.",
      },
      {
        icon: "ri-building-4-line",
        title: "Chautauqua Institution — The Summer Season Crunch",
        subtitle: "100,000+ seasonal visitors in a 9-week window",
        description: "The Chautauqua Institution's summer season (late June through August) creates the most concentrated passport demand of any small-town community in New York. Visiting lecturers, performers, artists, and seasonal residents — many from out of state — discover passport urgencies mid-season. Local acceptance facilities are overwhelmed during these 9 weeks, creating a bottleneck that affects year-round residents as well.",
        tip: "Chautauqua Institution seasonal residents should check passport validity before arriving in Jamestown. If you discover an issue mid-season, our expedited courier service bypasses the overwhelmed local acceptance facilities.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "SUNY Fredonia & Academic Travel",
        subtitle: "SUNY Fredonia — 25 miles north of Jamestown",
        description: "SUNY Fredonia's study abroad programs, faculty research travel, and international student population generate consistent passport demand from the Jamestown area. The university's semester calendar creates predictable crunch periods — September and January for study abroad departures, May for summer programs. Many Fredonia students are first-time passport applicants who need guidance through the entire process.",
        tip: "SUNY Fredonia students applying for first passports should start the process at least 8 weeks before their program departure date. The Fredonia Post Office offers acceptance services, but slots fill quickly near semester transitions.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "The Dual-Airport Dynamic — BUF vs ERI for Jamestown Travelers",
      description: "Jamestown's unique position between two airports — one in New York (BUF, 70 miles) and one in Pennsylvania (ERI, 40 miles) — creates a decision point for every trip. BUF offers more flights but is farther. ERI is closer but has fewer options. The key passport insight: both airports require valid documentation regardless of destination, and a passport issue at either means a long drive home with no flight.",
    },
  },
  destinations: {
    title: "Where Jamestown Travelers Go — And Why Passports Get Urgent",
    intro: "Jamestown's Chautauqua County location creates a distinctive mix of Canadian cross-border travel, European heritage tourism, and seasonal lake culture. Here's what drives passport urgency.",
    stats: [
      { stat: "44%", label: "of Jamestown expedited requests involve Canada — the highest Canada percentage in Western NY outside border cities" },
      { stat: "2–4 Weeks", label: "average lead time Jamestown travelers have from trip booking to international departure" },
      { stat: "Jun–Aug", label: "peak season when Chautauqua Institution, lake tourism, and summer family travel collide" },
      { stat: "36 Hours", label: "shortest turnaround we have accommodated for a Jamestown-to-Toronto traveler departing from BUF" },
    ],
    destinations: [
      { name: "Canada", context: "Toronto and Niagara Falls trips via Peace Bridge, Montreal weekends, Canadian lake country", urgency: "44% of all expedited requests — cross-border trips often booked 1–2 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Ireland & United Kingdom", context: "Strong Irish heritage in Western NY, BUF seasonal Dublin flights, Chautauqua heritage tours", urgency: "Summer heritage tours with fixed group departure dates", icon: "ri-map-pin-2-line" },
      { name: "Italy & Mediterranean", context: "Italian-American heritage in Jamestown and Fredonia, European lake district tours, culinary tourism", urgency: "Tour groups with 4–6 week booking-to-departure windows", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "Winter escape from Western NY, spring break resort vacations, all-inclusive packages", urgency: "Last-minute winter deals booked 3–4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Germany & Central Europe", context: "Western NY German heritage, manufacturing equipment travel, Christmas market tourism", urgency: "Trade fair dates are fixed and unmovable", icon: "ri-map-pin-2-line" },
      { name: "Poland & Eastern Europe", context: "Strong Polish-American community in Dunkirk and Buffalo corridor, heritage and family reunification", urgency: "Family events with 2–3 week notice", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other Western New York Service Areas",
    crossLinksDesc: "We serve travelers across Western New York with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Buffalo", route: "/buffalo" },
      { name: "Elmira", route: "/elmira" },
      { name: "Corning", route: "/corning" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Jamestown", address: "910 Fairmount Avenue, Jamestown, NY 14701", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Jamestown", address: "349 Fluvanna Avenue, Jamestown, NY 14701", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Walmart Photo Center — Jamestown", address: "350 E Fairmount Avenue, Jamestown, NY 14701", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "The UPS Store — Lakewood", address: "295 E Fairmount Avenue, Lakewood, NY 14750", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "CVS Pharmacy — Dunkirk", address: "175 E 4th Street, Dunkirk, NY 14048", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Fredonia", address: "40 E Main Street, Fredonia, NY 14063", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "CVS Pharmacy — Westfield", address: "7570 Route 20, Westfield, NY 14787", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/photo" },
    { name: "Walmart Photo Center — Dunkirk", address: "3955 Vineyard Drive, Dunkirk, NY 14048", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Jamestown",
      address: "512 Falconer Street, Jamestown, NY 14701",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Dunkirk",
      address: "309 Lake Shore Drive West, Dunkirk, NY 14048",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Full-service DMV office for northern Chautauqua County. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BUF",
      name: "Buffalo Niagara International Airport",
      distance: "About 70 miles from Jamestown",
      address: "4200 Genesee Street, Buffalo, NY 14225",
      note: "Western New York's primary international airport with direct flights to major U.S. hubs and seasonal international service including Dublin. Primary departure point for Chautauqua County travelers.",
      flightUrl: "https://www.buffaloairport.com/",
      flightLabel: "Buffalo Airport Website",
      featured: true,
    },
    {
      code: "ERI",
      name: "Erie International Airport (Pennsylvania)",
      distance: "About 40 miles from Jamestown",
      address: "4411 W 12th Street, Erie, PA 16505",
      note: "Jamestown's closest airport across the state line in Pennsylvania. Flights to Charlotte, Chicago, and connecting hubs. Convenient but more limited route network than BUF.",
      flightUrl: "https://www.erieairport.org/",
      flightLabel: "Erie Airport Website",
      featured: false,
    },
    {
      code: "ROC",
      name: "Greater Rochester International Airport",
      distance: "About 130 miles from Jamestown",
      address: "1200 Brooks Avenue, Rochester, NY 14624",
      note: "Upstate New York airport with flights to major U.S. hubs. Alternative for Jamestown travelers seeking different airline options than BUF or ERI.",
      flightUrl: "https://www.flyrga.com/",
      flightLabel: "Rochester Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the NYS Department of Health Vital Records. Online, mail, or in-person options available for Chautauqua County residents.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the NYS Department of Health Vital Records. Required for estate and legal matters in Chautauqua County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Chautauqua County Clerk in Mayville. Certified copies available for name changes and legal purposes.",
      url: "https://www.chqgov.com/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Chautauqua County Supreme Court Clerk. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/",
    },
  ],
};

export default jamestownConfig;